<template>
    <b-card-text>
        <p class="mb-0" style="font-size: 21px"><b>Datos Usuario Principal</b></p>
        <b-row>
            <b-col cols="12" md="6">
                <ValidationProvider name="Tipo Documento"  v-slot="{ errors, valid }">
                    <b-form-group 
                        label="Tipo Documento:"
                        label-for="formDataIdentificationDocumentType">
                        <b-form-select
                            v-model="formData.tipo_documento"
                            :options="tipoDocumentoCliente"
                            id="formDataIdentificationDocumentType"
                            class="mb-3"
                            value-field="tipo"
                            text-field="label"
                            required
                            :state="errors[0] ? false : (valid ? true : null)"
                            disabled-field="notEnabled"
                            >
                            <template #first>
                                <b-form-select-option value="">SELECCIONE</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-form-invalid-feedback>
                            {{ errors[0] }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col cols="12" md="6">
                <ValidationProvider name="Numero documento"  rules="required|min:3" v-slot="{ errors, valid }">
                    <b-form-group 
                        label="Numero de Documento:"
                        label-for="formDataIdentificationDocumentNumber">
                        <b-form-input
                            id="formDataIdentificationDocumentNumber"
                            v-model="formData.documento"
                            type="text"
                            autocomplete="off"
                            required
                            :state="errors[0] ? false : (valid ? true : null)"
                            placeholder="Ingrese el numero de documento"
                            ></b-form-input>
                        <b-form-invalid-feedback>
                            {{ errors[0] }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col cols="12" md="6">
                <ValidationProvider name="Nombre" rules="required|min:3" v-slot="{ errors, valid }">
                    <b-form-group 
                        label="Nombre:"
                        label-for="formDataUserName">
                        <b-form-input
                            id="formDataUserName"
                            v-model="formData.nombre"
                            type="text"
                            autocomplete="off"
                            required
                            :state="errors[0] ? false : (valid ? true : null)"
                            placeholder="Ingrese el nombre"
                            ></b-form-input>
                        <b-form-invalid-feedback>
                            {{ errors[0] }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col cols="12" md="6">
                <ValidationProvider name="Email"  rules="required|email" v-slot="{ errors, valid }">
                    <b-form-group 
                        label="Email:"
                        label-for="formDataUserEmail">
                        <b-form-input
                            id="formDataUserEmail"
                            v-model="formData.email"
                            type="text"
                            autocomplete="off"
                            required
                            :state="errors[0] ? false : (valid ? true : null)"
                            placeholder="Ingrese el correo"
                            ></b-form-input>
                        <b-form-invalid-feedback>
                            {{ errors[0] }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col cols="12" md="6">
                <ValidationProvider name="Telefono"  rules="required" v-slot="{ errors, valid }">
                    <b-form-group
                        label="Telefono:"
                        label-for="formDataUserPhoneNumber">
                        <b-form-input
                        id="formDataUserPhoneNumber"
                        v-model="formData.telefono"
                        type="text"
                        autocomplete="off"
                        required
                        placeholder="Ingrese el telefono"
                        :state="errors[0] ? false : (valid ? true : null)"
                        ></b-form-input>
                        <b-form-invalid-feedback>
                            {{ errors[0] }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col cols="12" md="6">
                <ValidationProvider name="Departamento" v-slot="{ errors, valid }">
                    <b-form-group 
                        label="Departamento:"
                        label-for="formDataUserProvinceId">
                        <b-form-select
                            v-model="formData.departamento_id"
                            :options="provinces_list"
                            id="formDataUserProvinceId"
                            class="mb-3"
                            value-field="id"
                            text-field="nombre"
                            :state="errors[0] ? false : (valid ? true : null)"
                            @change="getCitiesList()"
                            >
                            <template #first>
                                <b-form-select-option value="">SELECCIONE</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-form-invalid-feedback>
                            {{ errors[0] }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col cols="12" md="6">
                <ValidationProvider name="Ciudad" v-slot="{ errors, valid }">
                    <b-form-group 
                        label="Ciudad:"
                        label-for="formDataUserCityId">
                        <b-form-select
                            v-model="formData.ciudad_id"
                            :options="cities_list"
                            id="formDataUserCityId"
                            class="mb-3"
                            value-field="id"
                            text-field="nombre"
                            :state="errors[0] ? false : (valid ? true : null)"
                            >
                            <template #first>
                                <b-form-select-option value="">SELECCIONE</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-form-invalid-feedback>
                            {{ errors[0] }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col cols="12" md="12">
                <ValidationProvider name="Dirección" v-slot="{ errors, valid }">
                    <b-form-group 
                        label="Dirección:"
                        label-for="formDataUserAddress">
                        <b-form-textarea
                            id="formDataUserAddress"
                            v-model="formData.direccion"
                            type="text"
                            autocomplete="off"
                            :state="errors[0] ? false : (valid ? true : null)"
                            placeholder="Ingrese la dirección"
                            ></b-form-textarea>
                        <b-form-invalid-feedback>
                            {{ errors[0] }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
        </b-row>
    </b-card-text>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
export default {
    name: "UserMasterForm",
    props: {
        formData: {
            type: Object
        }
    },
    computed: {
        ...mapState('configuration', ['tipoDocumentoCliente'])
    },
    data() {
        return {
            provinces_list: [],
            cities_list: [],
        }
    },
    watch: {
        'formData.departamento_id': 'getCitiesList'
    },
    mounted() {
        this.getProvincesList(); // Carga provincias al montar el componente
    },
    methods: {
        ...mapMutations(['setLoading']),
        async getProvincesList() {
            this.setLoading(true);
            try {
                const response = await this.$conectar.post('direcciones/get-departamentos-list');
                this.provinces_list = response.data.departamentosList;
            } catch (e) {
                console.log(e.response);
            } finally {
                this.setLoading(false);
            }
        },
        async getCitiesList() {
            if (!this.formData.departamento_id) return; // Si no hay departamento seleccionado, no ejecuta
            this.setLoading(true);
            try {
                const response = await this.$conectar.post('direcciones/get-ciudades-list', {
                    departamento_id: this.formData.departamento_id
                });
                this.cities_list = response.data.ciudadesList;
            } catch (e) {
                console.log(e.response);
            } finally {
                this.setLoading(false);
            }
        },
    }
}
</script>